// UI Components
import ReviewStars from '@/components/ui/ReviewStars/ReviewStars.vue';
import UserIcon from '@/components/ui/UserIcon/UserIcon.vue';

// UI Components (Widgets)
import ChangeStat from '@/components/ui/ChangeStat/ChangeStat.vue';
import ChangeStatLarge from '@/components/ui/ChangeStatLarge/ChangeStatLarge.vue';
import LineChart from '@/components/ui/LineChart/LineChart.vue';
import PercentageCardContents from '@/components/ui/PercentageCardContents/PercentageCardContents.vue';

// Services
import RetailersService from '@/services/RetailersService.js';
import MultiSitesService from '@/services/MultiSitesService.js';
import ServiceProvidersService from '@/services/ServiceProvidersService.js';
import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';
import ReviewsService from '@/services/ReviewsService.js';
import IssuesService from '@/services/IssuesService.js';

// EventBus
import { EventBus } from '@/EventBus.js';

// Vendor
import moment from 'moment';

export default {

  name: 'Dashboard',

  components: {
    ChangeStat,
    ChangeStatLarge,
    ReviewStars,
    LineChart,
    UserIcon,
    PercentageCardContents
  },

  created: function(){

  },

  beforeDestroy: function(){

  },

  created: function() {
    if(this.userGroup == 'retailers') {
      this.initRetailer();
    }
    else if(this.userGroup == 'multi-site-retailers') {
      this.initMultisite();
    }
    else if(this.userGroup == 'service-providers') {
      this.initServiceProvider();
    }
    else if(this.userGroup == 'hsg-admins') {
      this.initHsgAdmin();
    }
  },

  mounted: function() {

  },

  data: function() {
    return {
      // Parse LocalStorage
      userGroup: localStorage.getItem('userGroup'),
      parentId: localStorage.getItem('parentId'),

      // Retailer data
      retailer: {
        // State
        activeChart: 1,

        // Widgets
        totalReviews: null,
        recentReviews: null,
        recentReviewsData: null,
        totalIssues: null,
        recentIssues: null,
        totalOpenIssues: null,
        totalClosedIssues: null,

        // Charts
        recentReviewsPerDay: null,
        recentAverageRatingPerDay: null
      },

      // Multisite data
      multisite: {
        // State
        activeChart: 1,

        // Widgets
        totalRetailers: null,
        newRetailers: null,
        totalReviews: null,
        recentReviews: null,
        recentReviewsData: null,
        totalIssues: null,
        recentIssues: null,
        totalOpenIssues: null,
        totalClosedIssues: null,

        // Charts
        recentReviewsPerDay: null,
        recentAverageRatingPerDay: null
      },


      // ServiceProvider data
      serviceProvider: {
        // State
        activeChart: 1,

        // Widgets
        totalRetailers: null,
        recentRetailers: null,
        totalMultisiteRetailers: null,
        recentMultisiteRetailers: null,
        totalReviews: null,
        recentReviews: null,
        recentReviewsData: null,
        totalIssues: null,
        totalOpenIssues: null,
        totalClosedIssues: null,

        // Charts
        recentReviewsPerDay: null,
        recentAverageRatingPerDay: null
      },

      // HSG Admin data
      hsgadmin: {
        // State
        activeChart: 1,

        // Widgets
        totalRetailers: null,
        newRetailers: null,
        totalMultisiteRetailers: null,
        newMultisiteRetailers: null,
        totalServiceProviders: null,
        newServiceProviders: null,
        totalReviews: null,
        totalIssues: null,

        // Charts
        recentReviewsPerDay: null,
        recentAverageRatingPerDay: null
      }
    }
  },

  computed: {
    retailerTotalOpenIssuesPercentage: function() {
      return (this.retailer.totalOpenIssues / this.retailer.totalIssues) * 100;
    },

    retailerTotalClosedIssuesPercentage: function() {
      return (this.retailer.totalClosedIssues / this.retailer.totalIssues) * 100;
    },

    multisiteTotalOpenIssuesPercentage: function() {
      return (this.multisite.totalOpenIssues / this.multisite.totalIssues) * 100;
    },

    multisiteTotalClosedIssuesPercentage: function() {
      return (this.multisite.totalClosedIssues / this.multisite.totalIssues) * 100;
    },

    serviceProviderTotalOpenIssuesPercentage: function() {
      return (this.serviceProvider.totalOpenIssues / this.serviceProvider.totalIssues) * 100;
    },

    serviceProviderTotalClosedIssuesPercentage: function() {
      return (this.serviceProvider.totalClosedIssues / this.serviceProvider.totalIssues) * 100;
    },
  },

  methods: {
    initRetailer: function() {
      let startDate = (moment().subtract(1, 'weeks').unix()) * 1000;

      // Total Reviews
      // -------------
      ReviewsService.getAll({retailer: this.parentId}, null, null, 'createdAt DESC')
        .then((res) => {
          this.retailer.totalReviews = res.data.length;

          // Recent Reviews
          // ---------------------
          let reviewsLast7Days = res.data.filter((r) => {
            if(r.createdAt > startDate) {
              return true;
            }
          });

          this.retailer.recentReviews = reviewsLast7Days.length;

          // Recent Reviews (Data) for List
          // ------------------------------
          this.retailer.recentReviewsData = res.data.slice(0, 4);
        });

      // Reviews Per Day (Chart Data)
      // ----------------------------
      ReviewsService.getPerDay(7, {retailer: this.parentId}, null, null, 'createdAt ASC')
        .then((res) => {
          this.retailer.recentReviewsPerDay = res.data;
        });

      // Average Rating Per Day (Chart Data)
      // -----------------------------------
      ReviewsService.getAverageRatingPerDay(7, {retailer: this.parentId}, null, null, 'createdAt ASC')
        .then((res) => {
          this.retailer.recentAverageRatingPerDay = res.data;
        });

      // Total Issues
      // ------------
      IssuesService.getAll({retailer: this.parentId}, null, null, 'createdAt ASC')
        .then((res) => {
          this.retailer.totalIssues = res.data.length;

          // Recent Issues
          // ---------------------
          let issuesLast7Days = res.data.filter((i) => {
            if(i.createdAt > startDate) {
              return true;
            }
          });

          this.retailer.recentIssues = issuesLast7Days.length;

          let openIssueStatuses = [
            'unread',
            'resolved-by-retailer',
            'confirmed',
            'resolution-in-progress',
            'resolution-awaiting-approval',
            'resolution-denied'
          ];

          let closedIssueStatuses = [
            'denied',
            'resolution-accepted',
          ];

          // Open Issues
          // -----------
          let totalOpenIssues = res.data.filter((i) => {
            if(openIssueStatuses.indexOf(i.status) > -1) {
              return true;
            }

            return false;
          });

          this.retailer.totalOpenIssues = totalOpenIssues.length;

          // Closed Issues
          // -------------
          let totalClosedIssues = res.data.filter((i) => {
            if(closedIssueStatuses.indexOf(i.status) > -1) {
              return true;
            }

            return false;
          });

          this.retailer.totalClosedIssues = totalClosedIssues.length;
        });
    },

    initMultisite: function() {
      let startDate = (moment().subtract(1, 'weeks').unix()) * 1000;

      RetailersService.getAll({multiSite: this.parentId})
        .then((res) => {
          // Total Retailers
          // ---------------
          this.multisite.totalRetailers = res.data.length;

          // New Retailers (last 7 days)
          // ---------------------------
          let retailersLast7Days = res.data.filter((r) => {
            if(r.createdAt > startDate) {
              return true;
            }
          });

          this.multisite.newRetailers = retailersLast7Days.length;

          // Filter for Reviews and Issues
          let reviewFilters = [];

          for (let r in res.data) {
            reviewFilters.push({retailer: res.data[r].id});
          }

          // Total Reviews
          // -------------
          ReviewsService.getAll(reviewFilters, 'or', null, 'createdAt DESC')
            .then((res) => {
              this.multisite.totalReviews = res.data.length;

              // Recent Reviews
              // ---------------------
              let reviewsLast7Days = res.data.filter((r) => {
                if(r.createdAt > startDate) {
                  return true;
                }
              });

              this.multisite.recentReviews = reviewsLast7Days.length;

              // Recent Reviews (Data) for List
              // ------------------------------
              this.multisite.recentReviewsData = res.data.slice(0, 4);
            });

          // Reviews Per Day (Chart Data)
          // ----------------------------
          ReviewsService.getPerDay(7, reviewFilters, 'or', null, 'createdAt ASC')
            .then((res) => {
              this.multisite.recentReviewsPerDay = res.data;
            });

          // Average Rating Per Day (Chart Data)
          // -----------------------------------
          ReviewsService.getAverageRatingPerDay(7, reviewFilters, 'or', null, 'createdAt ASC')
            .then((res) => {
              this.multisite.recentAverageRatingPerDay = res.data;
            });

          // Total Issues
          // ------------
          IssuesService.getAll(reviewFilters, 'or', null, 'createdAt ASC')
            .then((res) => {
              this.multisite.totalIssues = res.data.length;

              // Recent Issues
              // ---------------------
              let issuesLast7Days = res.data.filter((i) => {
                if(i.createdAt > startDate) {
                  return true;
                }
              });

              this.multisite.recentIssues = issuesLast7Days.length;

              let openIssueStatuses = [
                'unread',
                'resolved-by-retailer',
                'confirmed',
                'resolution-in-progress',
                'resolution-awaiting-approval',
                'resolution-denied'
              ];

              let closedIssueStatuses = [
                'denied',
                'resolution-accepted',
              ];

              // Open Issues
              // -----------
              let totalOpenIssues = res.data.filter((i) => {
                if(openIssueStatuses.indexOf(i.status) > -1) {
                  return true;
                }

                return false;
              });

              this.multisite.totalOpenIssues = totalOpenIssues.length;

              // Closed Issues
              // -------------
              let totalClosedIssues = res.data.filter((i) => {
                if(closedIssueStatuses.indexOf(i.status) > -1) {
                  return true;
                }

                return false;
              });

              this.multisite.totalClosedIssues = totalClosedIssues.length;
            });
        })
        .catch((err) => {

        });
    },

    initServiceProvider: function() {
      let startDate = (moment().subtract(1, 'weeks').unix()) * 1000;

      ServiceRelationshipsService.getAll({serviceProvider: this.parentId, status: 'approved'})
        .then((res) => {
          let retailersFilter = [];

          for(let i in res.data) {
            retailersFilter.push({id: res.data[i].retailer.id});
          }

          RetailersService.getAll(retailersFilter, 'or')
            .then((res) => {
              // Total Retailers
              // ---------------
              this.serviceProvider.totalRetailers = res.data.length;

              // New Retailers (last 7 days)
              // ---------------------------
              let retailersLast7Days = res.data.filter((r) => {
                if(r.createdAt > startDate) {
                  return true;
                }
              });

              this.serviceProvider.recentRetailers = retailersLast7Days.length;

              // Multisite and Review Filters
              // ----------------------------
              let retailerIds = [];
              let multisiteFilters = [];
              let reviewFilters = [];

              // Get DISTINCT ids of retailers that this SP services
              for(let i in res.data) {
                reviewFilters.push({retailer: res.data[i].id});

                // If we have a multisite ID
                if(res.data[i].retailer && res.data[i].multiSite) {
                  if(retailerIds.indexOf(res.data[i].retailer.multiSite) == -1) {
                    retailerIds.push(res.data[i].retailer.multiSite);

                    multisiteFilters.push({id: res.data[i].retailer.multiSite});
                  }
                }
              }

              // Total Multisites
              // ----------------
              if(multisiteFilters.length > 0) {
                MultiSitesService.getAll(multisiteFilters, 'or', null, 'name ASC')
                  .then((res) => {
                    this.serviceProvider.totalMultisiteRetailers = res.data.length;

                    // New Multisite Retailers (last 7 days)
                    // -------------------------------------
                    let multisiteRetailersLast7Days = res.data.filter((r) => {
                      if(r.createdAt > startDate) {
                        return true;
                      }
                    });

                    this.serviceProvider.recentMultisiteRetailers = multisiteRetailersLast7Days.length;
                  });
              }
              else {
                this.serviceProvider.totalMultisiteRetailers = 0;
                this.serviceProvider.recentMultisiteRetailers = 0;
              }

              // Total Reviews
              // -------------
              if(reviewFilters.length > 0) {
                ReviewsService.getAll(reviewFilters, 'or', null, 'createdAt DESC')
                  .then((res) => {
                    let issueStatuses = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];

                    let matchingReviews = res.data.filter((item) => {
                      for(let i in item.issues) {
                        if(item.issues[i].serviceProvider == this.parentId && issueStatuses.indexOf(item.issues[i].status) > -1) {
                          return true;
                        }
                      }

                      return false;
                    });

                    this.serviceProvider.totalReviews = matchingReviews.length;

                    // New Reviews (last 7 days)
                    // -------------------------
                    let reviewsLast7Days = matchingReviews.filter((r) => {
                      if(r.createdAt > startDate) {
                        return true;
                      }
                    });

                    this.serviceProvider.recentReviews = reviewsLast7Days.length;


                    // Recent Reviews (Table Data)
                    // ---------------------------
                    this.serviceProvider.recentReviewsData = matchingReviews.sort(function(a, b) {
                      if(a.createdAt > b.createdAt) {
                        return -1;
                      }
                      if(a.createdAt < b.createdAt) {
                        return 1;
                      }

                      return 0;
                    });

                    // Reviews Over Time (Chart Data)
                    // ------------------------------
                    let a = moment().subtract(6, 'days').hours(0).minutes(0).seconds(0);
                    let b = moment().add(1, 'days').hours(0).minutes(0).seconds(0);

                    let results = [];

                    // Iterate over each day until now
                    for (let m = moment(a); m.isBefore(b); m.add(1, 'days')) {
                      let reviewsForDay = {
                        date: m.format('D.M.Y'),
                        timestamp: m.valueOf()
                      };

                      reviewsForDay.reviews = matchingReviews.filter((r) => {
                        let reviewDate = moment(r.createdAt).hours(0).minutes(0).seconds(0);

                        if(reviewDate.isSame(m, 'day')) {
                          return true;
                        }

                        return false;
                      });

                      results.push(reviewsForDay);
                    }

                    this.serviceProvider.recentReviewsPerDay = results;

                    // Average Rating Over Time (Chart Data)
                    // -------------------------------------
                    let avgA = moment().subtract(6, 'days').hours(0).minutes(0).seconds(0);
                    let avgB = moment().add(1, 'days').hours(0).minutes(0).seconds(0);

                    let avgResults = [];

                    // Iterate over each day until now
                    for (let m = moment(avgA); m.isBefore(avgB); m.add(1, 'days')) {
                      let totalScore = 0;

                      let reviewsForDay = matchingReviews.filter((r) => {
                        let reviewDate = moment(r.createdAt).hours(0).minutes(0).seconds(0);

                        if(reviewDate.isSameOrBefore(m, 'day')) {
                          return true;
                        }

                        return false;
                      });

                      for(let i in reviewsForDay) {
                        totalScore += reviewsForDay[i].overallRating;
                      }

                      let averageRating = (totalScore / reviewsForDay.length) || 0;

                      // Push result for day onto response data
                      avgResults.push({
                        date: m.format('D.M.Y'),
                        timestamp: m.valueOf(),
                        averageRating: Math.round(averageRating * 10) / 10
                      })
                    }

                    this.serviceProvider.recentAverageRatingPerDay = avgResults;

                    // Total Issues
                    // ------------
                    let issueCount = 0;
                    for (let i in res.data) {
                      let matchingIssues = res.data[i].issues.filter((item) => {
                        if(item.serviceProvider == this.parentId && (item.status != 'unread' && item.status != 'denied')) {
                          return true;
                        }

                        return false;
                      });
                      issueCount += matchingIssues.length;
                    }
                    this.serviceProvider.totalIssues = issueCount;

                    // Open Issues
                    // ------------
                    let openIssueCount = 0;
                    for (let i in res.data) {
                      let matchingOpenIssues = res.data[i].issues.filter((item) => {
                        if(item.serviceProvider == this.parentId && issueStatuses.indexOf(item.status) > -1) {
                          return true;
                        }

                        return false;
                      });

                      openIssueCount += matchingOpenIssues.length;
                    }
                    this.serviceProvider.totalOpenIssues = openIssueCount;

                    // Closed Issues
                    // -------------
                    let closedIssueCount = 0;
                    for (let i in res.data) {
                      let matchingClosedIssues = res.data[i].issues.filter((item) => {
                        if(item.serviceProvider == this.parentId && item.status == 'resolution-accepted') {
                          return true;
                        }

                        return false;
                      });

                      closedIssueCount += matchingClosedIssues.length;
                    }
                    this.serviceProvider.totalClosedIssues = closedIssueCount;
                  });
              }
              else {
                this.serviceProvider.totalReviews = 0;
                this.serviceProvider.recentReviews = 0;
              }
            });
        });
    },

    initHsgAdmin: function() {
      let startDate = (moment().subtract(1, 'weeks').unix()) * 1000;

      // Reviews Per Day (Chart Data)
      // ----------------------------
      ReviewsService.getPerDay(7, null, null, null, 'createdAt DESC')
        .then((res) => {
          this.hsgadmin.recentReviewsPerDay = res.data;
        });

      RetailersService.getAll()
        .then((res) => {
          // Total Retailers
          // ---------------
          this.hsgadmin.totalRetailers = res.data.length;

          // New Retailers (last 7 days)
          // ---------------------------
          let retailersLast7Days = res.data.filter((r) => {
            if(r.createdAt > startDate) {
              return true;
            }
          });

          this.hsgadmin.newRetailers = retailersLast7Days.length;
        });

        MultiSitesService.getAll()
          .then((res) => {
            // Total Multisites
            // ---------------
            this.hsgadmin.totalMultisiteRetailers = res.data.length;

            // New Multisites (last 7 days)
            // ---------------------------
            let retailersLast7Days = res.data.filter((r) => {
              if(r.createdAt > startDate) {
                return true;
              }
            });

            this.hsgadmin.newMultisiteRetailers = retailersLast7Days.length;
          });

          ServiceProvidersService.getAll()
            .then((res) => {
              // Total Service Provders
              // ----------------------
              this.hsgadmin.totalServiceProviders = res.data.length;

              // New Service Provders (last 7 days)
              // ----------------------------------
              let retailersLast7Days = res.data.filter((r) => {
                if(r.createdAt > startDate) {
                  return true;
                }
              });

              this.hsgadmin.newServiceProviders = retailersLast7Days.length;
            });

      // Total Reviews
      // -------------
      ReviewsService.getAll(null, null, null, 'createdAt DESC')
      .then((res) => {
        this.hsgadmin.totalReviews = res.data.length;
      });

      // Total Issues
      // ------------
      IssuesService.getAll(null, null, null, 'createdAt ASC')
      .then((res) => {
        this.hsgadmin.totalIssues = res.data.length;
      });
    },

    // Utility methods
    timestampToDateShort: function(timestamp) {
        return moment(timestamp).format('D.M.Y');
    },

    reviewsPerDayLabels: function(data) {
      if(data !== null) {
        let labels = [];

        for (let i in data) {
          labels.push(moment(data[i].timestamp).format('ddd'));
        }

        return labels;
      }

      return null;
    },

    reviewsPerDayPlots: function(data) {
      if(data !== null) {
        let plots = [];

        for (let i in data) {
          plots.push(data[i].reviews.length);
        }

        return plots;
      }

      return null;
    },

    averageRatingPerDayLabels: function(data) {
      if(data !== null) {
        let labels = [];

        for (let i in data) {
          labels.push(moment(data[i].timestamp).format('ddd'));
        }

        return labels;
      }

      return null;
    },

    averageRatingPerDayPlots: function(data) {
      if(data !== null) {
        let plots = [];

        for (let i in data) {
          plots.push(data[i].averageRating);
        }

        return plots;
      }

      return null;
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/Dashboard.js